import react, { useCallback, useEffect, useState } from "react";
// import Cookies from "js-cookie";
import axios from "axios";
import { resources } from "../Resourses/Resources";
import { IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

const successMessage = (message) => {
  toast.success(message, {
    position: "top-center",
    toastId: "success1",
    // className: "success",
  });
};

const errorMessage = (message) => {
  toast.error(message, {
    position: "top-center",
    toastId: "error1",
    // className: "error",
  });
};

const ViewStudentEnquiryForm = () => {
  // const useData = Cookies.get("userDetails");
  // const userDetails = JSON.parse(useData);
  // const [departMent, setDepartment] = useState("");
  // const [userName, setUserName] = useState("");
  const [editpop, setEditpop] = useState(false);
  const [editInputs, setEditInputs] = useState({})
  const [enquiryFormDetails, setEnquiryFormDetails] = useState([
    {
      uniqueKey: "",
      name: "",
      subject: "",
      mail: "",
      rollNumber: "",
      feedBack: "",
      departMent: "",
      message: "",
      status: "",
    }
  ]);

  // useEffect(() => {
  //   const roll = userDetails.username;
  //   const branchdata = userDetails.program;
  //   setUserName(userDetails.username);
  //   setDepartment(userDetails.program);
  // }, []);
  // useEffect(() => {
  //   console.log("rollNumber===>", userName);
  //  const handleFetch = async()=>{
  //   if (userName !== null && userName !== "") {
  //     const fetchEnquiryForm = async () => {
  //       try {
  //         const response = await axios.get(
  //           resources.APPLICATION_URL +
  //           `getAllEnquiryFormsByRollNumber?userName=${userName}`
  //         );
  //         if (response.data) {
  //           setEnquiryFormDetails(response.data);
  //         }
  //       } catch (error) {
  //         console.log("error===>", error);
  //       }
  //     };
  //     fetchEnquiryForm();
  //     handleFetch();
  //   }
  //  }
  // }, [userName]);
  const handleFetch = useCallback(async () => {

      try {
        const response = await axios.get(
          // `${resources.APPLICATION_URL}getAllEnquiryFormsByRollNumber?userName=${userName}`
          `${resources.APPLICATION_URL}getAllEnquiryFormsByRollNumber`
        );
        if (response.data) {
          setEnquiryFormDetails(response.data);
          setEditpop(false)
        }
      } catch (error) {
        console.log("Fetch error:", error);
      }

  });

  useEffect(() => {
    // console.log("rollNumber===>", userName);
    handleFetch();
  }, []);

  console.log("enquiryFormDetails===>", enquiryFormDetails);

  
  const handleDelete = async (uniqueKey) => {
    try {
      const responce = await axios.delete(`${resources.APPLICATION_URL}deleteEnquiryFeeback?uniqueKey=${uniqueKey}`)
      await handleFetch();
      console.log("delete=>", responce)
      if (responce.status === 200) {
        successMessage("Deleted successfully ", responce.data.message)
      }
    } catch {
      console.log("error")
      errorMessage("Error")
    }
  }
  const handleEdit = async () => {
    try {
      const ress = await axios.post(`${resources.APPLICATION_URL}saveAafterGivingFeedBack`, [editInputs])
      if (ress.status === 200) {
        successMessage("Update successfuly", ress.data.message)
        handleFetch()
      }
    } catch (error) {
      errorMessage("Error")

    }
  }

  return (
    <div>
      {!editpop && (
        <div>
          <table className="tableStylings">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Department</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {enquiryFormDetails &&
                enquiryFormDetails.length > 0 &&
                enquiryFormDetails.map((items, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{items.name}</td>
                      <td>{items.departMent}</td>
                      <td>{items.message}</td>
                      <td>
                        <IconButton onClick={() => {
                          setEditpop(true)
                          setEditInputs(items)
                          console.log("editInputsssss", items)
                        }}>
                          <EditIcon style={{ color: "green" }} />
                        </IconButton>
                        <IconButton onClick={() => { handleDelete(items.uniqueKey) }} >
                          <DeleteIcon style={{ color: "red" }} />
                        </IconButton>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div >
      )}
      {editpop && (
        <div>
          <div className="enQuiryFormConatainer">
            <h3 className="headersTag">ENQUIRY FORM <span onClick={()=>setEditpop(false)}><CloseIcon style={{ color: "white", background: "red",marginLeft:"100%",fontSize:"30px" }} />
            </span></h3>


            <div className="enquirySubdiv">
              <div className="enquirySubdivOne">
                <div className="enQuiryInputDiv">
                  <label htmlFor="Name">Role</label>
                  <input
                    value={enquiryFormDetails.rollNumber}
                    onChange={(e) =>setEnquiryFormDetails ({ ...enquiryFormDetails, rollNumber: e.target.value })}
                    type="text"
                    disabled="true"
                    id="Name"
                    placeholder="admin"
                    name="name"
                    required
                  />
                </div>
                <div className="enQuiryInputDiv">
                  <label htmlFor="Name">Name</label>
                  <input
                    value={editInputs.name}
                    onChange={(e) => setEditInputs({ ...editInputs, name: e.target.value })}
                    type="text"
                    placeholder="Enter Name"
                    id="Name"
                    name="name"
                    required
                  />
                </div>
                <div className="enQuiryInputDiv">
                  <label htmlFor="Department"></label>
                  <input
                  value={editInputs.departMent}
                  onChange={(e)=>setEditInputs({...editInputs,departMent:e.target.value})}

                    type="text"
                    placeholder="Department"
                    id="DepartMent"
                    name="departMent"
                    required
                  />
                </div>
                <div className="enQuiryInputDiv">
                  <label htmlFor="Email">Email</label>
                  <input
                    value={editInputs.mail}
                    onChange={(e)=>setEditInputs({...editInputs,mail:e.target.value})}
                    type="email"
                    placeholder="Email"
                    id="Email"
                    name="mail"
                    required
                  />
                </div>
                <div className="enQuiryInputDiv">
                  <label htmlFor="Contact">Contact</label>
                  <input
                    value={editInputs.contact}
                    onClick={(e)=>setEditInputs({...editInputs,contact:e.target.value})}
                    type="text" // We are using text to better control the input
                    placeholder="Contact"
                    id="Contact"
                    name="contact"
                    required
                  />
                </div>
              </div>
              <div className="enquirySubdivTwo">
                <label htmlFor="Message">Message</label>
                <textarea
                value={editInputs.message}
                onChange={(e)=>setEditInputs({...editInputs,message:e.target.value})}

                  name="message"
                  type="text"
                  cols={30}
                  rows={5}
                  placeholder="Message"
                  id="Message"
                  required
                />
              </div>
            </div>
            <div className="enquiryButtonDiv">
              <button
                className=""
                type="button"
                onClick={(e)=>{handleEdit(e)}}

              >
                Submit
              </button>
            </div>

          </div>
        </div>

      )}
    </div >
  );
};
export default ViewStudentEnquiryForm;
